import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AddNewMachineDrawerModal } from "@src/components/organisms/modals/add-new-machine-drawer-modal/add-new-machine-drawer-modal";

export const AddNewMachineDrawer = () => {
  const addNewMachineDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addNewMachineDrawerModal.showModal,
  );

  return <>{addNewMachineDrawerModal && <AddNewMachineDrawerModal />}</>;
};
